<template>
  <div class="order_detail">
    <div class="order_detail_container">
      <el-button size="small" @click="handleBack" icon="el-icon-arrow-left" class="back">返回</el-button>

      <!-- 订单状态步骤条 -->
      <!-- <el-row class="mt2 step_container" type="flex" justify="center">
        <el-col :span="8">
          <el-steps :active="active" process-status="success" :align-center="true">
            <el-step :title="item" v-for="(item, index) in stepList" :key="index"></el-step>
          </el-steps>
        </el-col>
      </el-row> -->

      <el-row class="mt1" type="flex" justify="flex-start">
        <el-col :span="19">
          <el-form ref="form" :inline="true" label-position="right" :model="form" label-width="120px">
            <!-- 小订信息 -->
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width: 450px">
                小订信息
                <span @click="toCustomer" class="toCustomer">客户详情</span>
              </div>
              <!-- <div class="title">{{ `APP小订订单号:${form.appSmallOrderId}` }}</div> -->
            </el-row>
            <el-row class="content-wrap">
              <el-form-item class="form_item" label="APP小订单号：">
                {{ form.AppPreOrderId }}
              </el-form-item>
              <el-form-item class="form_item" label="订单创建时间：">
                {{ form.createdTime }}
              </el-form-item>
              <el-form-item class="form_item" label="订单状态：">
                {{ smallOrderStatusMap.get(form.orderStatus) }}
              </el-form-item>
              <el-form-item class="form_item" label="小订订金：">
                {{ form.paydownMoney ? `${form.paydownMoney}元` : '' }}
              </el-form-item>
              <el-form-item class="form_item" label="实付金额：">
                {{ form.PaymentMoney ? `${form.PaymentMoney}元` : '' }}
              </el-form-item>
              <el-form-item class="form_item" label="是否已转大定：">
                {{ form.appOrderId ? '是' : '否' }}
              </el-form-item>
              <el-form-item class="form_item" label="关联大定订单编号：" label-width="140px">
                {{ form.appOrderId || '' }}
              </el-form-item>
            </el-row>

            <!-- 车辆信息 -->
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title">
                车辆信息
              </div>
            </el-row>
            <el-row class="content-wrap">
              <el-form-item class="form_item" label="订购车系：">
                {{ form.seriesName }}
              </el-form-item>
              <el-form-item class="form_item" label="订购车型：">
                {{ form.modelDisplay }}
              </el-form-item>
              <el-form-item v-if="form.carColor" class="form_item" label="外观：">
                {{ form.carColor }}
              </el-form-item>
              <el-form-item v-if="form.carInternalColor" class="form_item" label="内饰：">
                {{ form.carInternalColor }}
              </el-form-item>
              <el-form-item v-if="form.carWheel" class="form_item" label="轮胎：">
                {{ form.carWheel || '-' }}
              </el-form-item>
              <el-form-item v-if="form.carWheelBoss" class="form_item" label="轮毂：">
                {{ form.carWheelBoss || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option1" class="form_item" label="选装1：">
                {{ form.option1 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option2" class="form_item" label="选装2：">
                {{ form.option2 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option3" class="form_item" label="选装3：">
                {{ form.option3 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option4" class="form_item" label="选装4：">
                {{ form.option4 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option5" class="form_item" label="选装5：">
                {{ form.option5 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option6" class="form_item" label="选装6：">
                {{ form.option6 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option7" class="form_item" label="选装7：">
                {{ form.option7 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option8" class="form_item" label="选装8：">
                {{ form.option8 || '-' }}
              </el-form-item>
              <el-form-item v-if="form.option9" class="form_item" label="选装9：">
                {{ form.option9 || '-' }}
              </el-form-item>
            </el-row>

            <!-- 客户信息 -->
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title">客户信息</div>
            </el-row>
            <el-row class="content-wrap">
              <el-form-item class="form_item" label="订车人姓名：">
                {{ form.customerName }}
              </el-form-item>
              <el-form-item class="form_item" label="订车人电话：">
                {{ form.customerPhone }}
              </el-form-item>
              <el-form-item class="form_item" label="生日：">
                {{ form.customerBirthdayStr || '-' }}
              </el-form-item>
              <el-form-item class="form_item" label="省份：">
                {{ form.customerProvince }}
              </el-form-item>
              <el-form-item class="form_item" label="城市：">
                {{ form.customerCity }}
              </el-form-item>
            </el-row>

            <!-- 其他信息 -->
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title">其他信息</div>
            </el-row>
            <el-row class="content-wrap">
              <el-form-item class="form_item" label="退款原因：">
                {{ form.refundReason }}
              </el-form-item>
              <el-form-item class="form_item" label="退款申请时间：">
                {{ form.refundTime }}
              </el-form-item>
              <el-form-item class="form_item" label="退款状态：">
                {{ smallOrderRefundStatusMap.get(form.refundStatus) }}
              </el-form-item>
              <el-form-item class="form_item" label="支付时间：">
                {{ form.payTime }}
              </el-form-item>
              <el-form-item class="form_item" label="交易关闭时间：">
                {{ form.closeTime }}
              </el-form-item>
              <el-form-item class="form_item" label="备注：">
                {{ form.remark }}
              </el-form-item>
            </el-row>
          </el-form>
        </el-col>

        <!-- 订单操作记录 -->
        <el-col :span="5" class="ml2">
          <div class="title">订单操作记录</div>
          <el-row class="timeline-row">
            <el-timeline class="timeline-list">
              <el-timeline-item v-for="(item, index) in timelines" :key="index" color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')">
                <div class="boxLine">
                  <div class="boxLineTitle">{{ smallOrderStatusMap.get(item.preOrderStatus) }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/assets/js/util';
import { smallOrderStatusMap, smallOrderStepListMap, smallOrderRefundStatusMap } from "./constants.js"

const orderStatusType = [0, 1, 2]

export default {
  components: {
  },
  data() {
    return {
      smallOrderStatusMap,
      smallOrderRefundStatusMap,
      parseTime,
      dealer: this.$common.getLoginInfo().profile,
      active: 1,
      form: {
        AppPreOrderId: '',
        createdTime: '',
        orderStatus: '',
        paydownMoney: '',
        PaymentMoney: '',
        appOrderId: '',
       
        seriesName: '',
        modelDisplay: '',
        carColor: '',
        carInternalColor: '',
        carWheel: '',
        carWheelBoss: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        option5: '',
        option6: '',
        option7: '',
        option8: '',
        option9: '',

        customerName: '',
        customerPhone: '',
        customerBirthdayStr: '',
        customerProvince: '',
        customerCity: '',

        refundReason: '',
        refundTime: '',
        refundStatus: '',
        payTime: '',
        closeTime: '',
        remark: '',
      },
      timelines: [],
      stepList: ['未支付', '已支付', '已成交'],
    };
  },
  watch: {
  },
  computed: {

  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    // 返回
    handleBack() {
      if (this.$route.query.from === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      } else if (this.$route.query.from === "order") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      } else {
        this.$router.go(-1);
      }
    },
    // 跳转客户详情
    toCustomer() {
      if (this.form.customerId) {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      }
    },
    // 获取订单详情
    getOrderDetail() {
      this.$httpAuth
        .post("/v2/appCustomerService/preOrderDetail", {
          preOrderId: Number(this.$route.query.smallOrderId),
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          let data = res.data;
          const { preOrder = {}, timelines = [] } = data || {}

          this.form = preOrder
          this.timelines = timelines

          // let row = { list: [], step: 0 }
          // if (orderStatusType.includes(this.form.orderStatus)) {
          //   row = smallOrderStepListMap.get(this.form.orderStatus)
          // }
          // this.stepList = row.list;
          // this.active = row.step

        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
.order_detail {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

.order_detail_container {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.content-wrap {
  background: #fff;
  padding: 15px 0;
}

.content-wrap .el-form-item {
  width: 30%;
}

.step_container {
  background: #fff;
  padding: 35px 0 20px 0;
}

.back {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.ml2 {
  margin-left: 20px;
}


.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.title-left {
  width: 450px;
}

.title-right {
  text-align: right;
}

.form_item {
  margin-bottom: 15px !important;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.boxLine {
  /* width: 250px; */
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLineTitle {
  font-weight: 600;
  color: #000;
}

.timeline-row {
  min-height:196px;
  background:#fff; 
  max-height: 610px; 
  overflow-y: auto;
}

.timeline-list {
  margin:15px 10px 0 30px;
}
</style>
